var _style, _defs, _defs2, _defs3, _defs4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurveybotCmyk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 350,
    height: 70,
    x: "0px",
    y: "0px",
    viewBox: "0 0 175.75 34.02",
    style: {
      enableBackground: "new 0 0 175.75 34.02"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000052095853778251778290000002664653628754951867_);fill:none;stroke:#2B5B64;stroke-width:2;}\n\t.st1{clip-path:url(#SVGID_00000072256527540495149140000017375034108831487416_);fill:none;stroke:#2B5B64;stroke-width:2;}\n\t.st2{clip-path:url(#SVGID_00000126322049318944332550000017487878474556435897_);fill:#2B5B64;}\n\t.st3{clip-path:url(#SVGID_00000000205899385151466850000000127835070236135067_);fill:#6497A8;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.17,
    y: 0.7,
    width: 175.49,
    height: 32.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000037670454586075934470000002906976759212861332_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000037670454586075934470000002906976759212861332_)",
      fill: "none",
      stroke: "#2B5B64",
      strokeWidth: 2
    },
    d: " M166.27,31.58c4.43,0,8.39-5.03,8.39-11.25s-3.96-11.36-8.39-11.36"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000035527807637234118980000002119316296137756838_",
    x: 0.17,
    y: 0.7,
    width: 175.49,
    height: 32.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049180706732713720380000014184500250716096146_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000035527807637234118980000002119316296137756838_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000049180706732713720380000014184500250716096146_)",
      fill: "none",
      stroke: "#2B5B64",
      strokeWidth: 2
    },
    d: " M166.27,25.69c1.66,0,3.01-2.4,3.01-5.35c0-2.96-1.35-5.35-3.01-5.35"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000103260371411335311990000005761114985686308015_",
    x: 0.17,
    y: 0.7,
    width: 175.49,
    height: 32.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026842972755166938040000013902066174544667043_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103260371411335311990000005761114985686308015_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000026842972755166938040000013902066174544667043_)",
      fill: "#2B5B64"
    },
    d: "M162.51,15.23h-3.97 V10.3L154,11.67v3.55h-3.06v4.36H154v7.31c0,2.42,0.64,4.09,1.92,5.03c1.28,0.94,3.47,1.23,6.59,0.88V28.7 c-0.87,0.05-1.6,0.05-2.18,0.02s-1.03-0.19-1.34-0.48c-0.3-0.28-0.46-0.73-0.46-1.34v-7.31h3.97V15.23z M135.53,24.02 c0-1.41,0.45-2.57,1.35-3.48c0.9-0.91,2.03-1.37,3.39-1.37s2.5,0.46,3.41,1.37c0.91,0.91,1.37,2.08,1.37,3.48s-0.46,2.57-1.37,3.48 c-0.91,0.91-2.05,1.37-3.41,1.37s-2.49-0.46-3.39-1.37C135.98,26.59,135.53,25.43,135.53,24.02 M149.59,24.02 c0-2.6-0.9-4.8-2.71-6.59c-1.81-1.79-4.01-2.69-6.61-2.69c-2.6,0-4.8,0.9-6.59,2.69c-1.79,1.79-2.69,3.99-2.69,6.59 s0.9,4.8,2.69,6.59c1.79,1.79,3.99,2.69,6.59,2.69c2.6,0,4.81-0.9,6.61-2.69C148.69,28.82,149.59,26.62,149.59,24.02 M115.55,28.27 v-5.8h5.59c0.82,0,1.5,0.27,2.04,0.83s0.81,1.24,0.81,2.06c0,0.84-0.27,1.54-0.81,2.09c-0.54,0.55-1.22,0.83-2.04,0.83H115.55z  M122.31,13.5c0.49,0.52,0.74,1.16,0.74,1.93c0,0.77-0.25,1.42-0.76,1.93c-0.5,0.52-1.13,0.77-1.88,0.77h-4.85v-5.42h4.85 C121.18,12.73,121.81,12.99,122.31,13.5 M127.9,15.12c0-2.02-0.72-3.67-2.16-4.98c-1.44-1.3-3.22-1.95-5.33-1.95h-9.71v24.62h10.44 c2.16,0,3.97-0.67,5.45-2c1.48-1.34,2.22-3.05,2.22-5.14c0-2.51-1.08-4.38-3.24-5.63C127.12,18.8,127.9,17.16,127.9,15.12"
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000142866774144538737550000005485742464830638508_",
    x: 0.17,
    y: 0.7,
    width: 175.49,
    height: 32.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021805021680054859500000009135374486061981576_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142866774144538737550000005485742464830638508_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000021805021680054859500000009135374486061981576_)",
      fill: "#6497A8"
    },
    d: "M99.89,20.05L95.3,8.23 h-4.96l7.21,17.02c-0.42,1.19-0.99,2.06-1.71,2.6c-0.71,0.54-1.68,0.8-2.9,0.77v4.22c2.25,0.12,4.13-0.39,5.64-1.53 c1.51-1.14,2.72-2.96,3.64-5.47l6.41-17.61h-4.85L99.89,20.05z M78.19,12.75c0.8-0.62,1.81-0.93,3.02-0.93 c1.03,0,1.95,0.29,2.76,0.88c0.81,0.59,1.34,1.48,1.6,2.67h-8.97C76.87,14.24,77.4,13.37,78.19,12.75 M89.94,18.88 c0.12-0.66,0.18-1.28,0.18-1.86c0-2.63-0.84-4.83-2.51-6.61c-1.68-1.78-3.8-2.67-6.38-2.67c-2.72,0-4.95,0.89-6.68,2.66 c-1.74,1.77-2.6,3.98-2.6,6.63c0,2.67,0.88,4.89,2.64,6.65c1.76,1.76,4.09,2.64,7,2.64c3.38,0,5.93-1.25,7.67-3.76l-3.66-2.11 c-0.89,1.17-2.2,1.76-3.94,1.76c-2.7,0-4.35-1.1-4.96-3.31H89.94z M62.28,20.53L58.02,8.23h-4.99l6.68,17.58h5.17l6.68-17.58h-4.99 L62.28,20.53z M46.43,8.23h-4.54v17.58h4.54v-8.41c0-1.69,0.54-2.9,1.63-3.62c1.09-0.73,2.33-1.01,3.71-0.84V7.87 c-1.2,0-2.28,0.28-3.25,0.84c-0.97,0.56-1.67,1.41-2.09,2.53V8.23z M33.37,17.72c0,1.45-0.35,2.55-1.06,3.27 c-0.7,0.73-1.64,1.09-2.81,1.09c-1.06,0-1.9-0.31-2.53-0.93c-0.63-0.62-0.95-1.52-0.95-2.69V8.23h-4.54v10.8 c0,2.27,0.63,4.06,1.88,5.34c1.25,1.29,2.84,1.94,4.76,1.94c2.39,0,4.14-0.82,5.24-2.46v1.97h4.54V8.23h-4.54V17.72z M16.3,24.3 c1.65-1.34,2.48-3.14,2.48-5.42c0-0.7-0.09-1.35-0.26-1.95c-0.18-0.6-0.39-1.11-0.63-1.53c-0.25-0.42-0.6-0.83-1.07-1.23 c-0.47-0.4-0.88-0.72-1.25-0.95c-0.36-0.23-0.88-0.49-1.55-0.76c-0.67-0.27-1.2-0.47-1.58-0.6c-0.39-0.13-0.95-0.31-1.7-0.55 c-1.83-0.56-3.07-1.08-3.71-1.56C6.37,9.28,6.04,8.65,6.04,7.87c0-0.73,0.29-1.32,0.86-1.78c0.57-0.46,1.37-0.68,2.37-0.68 c2.16,0,3.73,1.06,4.71,3.16l4.08-2.36c-0.84-1.74-2.02-3.09-3.53-4.06C13.02,1.19,11.27,0.7,9.28,0.7c-2.23,0-4.13,0.66-5.72,1.99 c-1.58,1.32-2.37,3.1-2.37,5.33c0,1.13,0.2,2.11,0.6,2.95c0.4,0.84,0.98,1.54,1.74,2.09c0.76,0.55,1.52,0.99,2.29,1.32 c0.76,0.33,1.69,0.66,2.8,0.99c1.99,0.56,3.38,1.08,4.15,1.56c0.77,0.48,1.16,1.16,1.16,2.02c0,0.75-0.32,1.37-0.95,1.86 c-0.63,0.49-1.63,0.74-2.99,0.74c-2.81,0-4.7-1.25-5.66-3.76l-4.15,2.43c0.68,1.88,1.85,3.36,3.52,4.45 c1.66,1.09,3.72,1.64,6.15,1.64C12.49,26.3,14.64,25.63,16.3,24.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveybotCmyk);
export default __webpack_public_path__ + "static/media/Surveybot_CMYK.d6449d599bb0ef3e0099493e60c416cc.svg";
export { ForwardRef as ReactComponent };